String.prototype.toLanguageKey = function() {
    return jng.toLanguageKey(this)
}
String.prototype.contains = function (str) {
    return this.indexOf(str) >= 0
}

String.prototype.containsAsWord = function (str) {
    if (str.endsWith(' ' + str)) return true
    if (str.contains(' ' + str + ' ')) return true
    return false
}
String.prototype.replaceScheme = function(startWordRegex, lastWordRegex, replaceText){
    var n = this;
    return n.replace(n.substring(n.search(startWordRegex),n.search(lastWordRegex) + 1), replaceText);
}


String.prototype.getNumberOnly = function () {
    if (!isNaN(this)) return this
    var result = '';
    for(var i = 0; i < this.length; i++) {
        if (this[i] >= '0' && this[i] <= '9') {
            result += this[i]
        }
    }
    return result;
}

String.prototype.firstCharacterLower = function () {
    return this.substring(0, 1).toLowerCase() + this.substring(1);
}

String.prototype.toSentenceCase = function () {
    return this.substring(0, 1).toUpperCase() + this.toLowerCase().substring(1);
}

String.prototype.toTitleCase = function () {
    var strList = this.toLowerCase().split(' ');
    var result = '';
    for(var i = 0; i < strList.length; i++) {
        result += strList[i].toSentenceCase() + ' ';
    }
    if (result !== '') return result.substring(0, result.length - 1);
    return '';
}

String.prototype.toNumber = function (nanValue) {
    if (!isNaN(this)) {
        return Number(this);
    }
    return jng.coalesce(nanValue, 0);
}

String.prototype.padl = function (iWidth, opt_chFillWith) {
    var ch;
    ch = opt_chFillWith || '0';
    return this.length >= iWidth ? this.toString() : String.replicate(ch, iWidth - this.length) + this;
};

String.prototype.splitRemoveEmpty = function (separator) {
    var result = this.split(separator);
    var i;
    for (i = result.length - 1; i >= 0; i -= 1) {
        if (result[i] === "") {
            result.deleteAt(i);
        }
    }
    return result;
};

String.prototype.getPart = function (index, separator) {
    var result = this.split(separator);
    return result[index];
};

String.prototype.getToLastPart = function (separator, idx) {
    var result = '';
    var itemList = this.split(separator);
    var i;
    var lastIdx = itemList.length - 1 - jng.coalesce(idx, 0);
    for (i = 0; i <= lastIdx; i++) {
        result += itemList[i];
        if(i < lastIdx) result += '.';
    }
    return result;
}

String.prototype.getLastPart = function (separator, idx) {
    var result = this.split(separator);
    return result[result.length - 1 - jng.coalesce(idx, 0)];
};

String.prototype.splitLastPart = function (separator) {
    var result = this.split(separator);
    if (result.length == 0) return [];
    if (result.length == 1) return result;
    var leftPart = result[0];
    for(var idx = 1; idx < result.length - 1; idx++) {
        leftPart += '__' + result[idx]
    }
    return [leftPart, result[result.length - 1]];
};

String.prototype.concatUrl = function(data) {
    let concatUrl = this;
    if (concatUrl.endsWith('/')) {
        concatUrl = concatUrl.substring(0, concatUrl.length - 1)
    }
    if(jng.isDefined(data)) {
      if (jng.isArray(data)) {
        let joinData = data.reduce((acc, value) => acc + '/' + value, '');
        while(joinData.indexOf('//') > -1) {
            joinData = joinData.replace('//', '/');
        }
        concatUrl += joinData;
      } else {
        concatUrl += '/' + data;
      }
    }
    return concatUrl;
  }
String.prototype.replaceToSomething = function(stringStyle){
    let start = "";
    let startEl = "";

    let end = "";
    let endEl = "";
    
    let value = this;
    if(value.length>0){
        if(value[0]=="_")value = " "+value;
    }
    if(stringStyle == "italic"){
        start = / _/g;
        end = /_ /g;
        startEl = " <span style='font-style: italic;font-size: inherit;line-height:inherit'>";
        endEl = "</span> ";
    }

    if(stringStyle !== ""){
        let val = value.replace(start, startEl);
        val += " ";
        val = val.replace(end, endEl)
        value = val;
    }

    return value
}

String.prototype.replaceFromFindReplace = function(iFrom, countFrom,szFindWord, szReplaceWord){
    let lastWord = "";
    let value = this;

    if(countFrom == "last"){
        lastWord = value.slice(value.length - iFrom, value.length);

        value = value.slice(0, value.length - iFrom);
    }else{
        lastWord = value.slice(0, iFrom);

        value = value.slice(iFrom, value.length);
    }
    lastWord = lastWord.replace(RegExp(szFindWord, "g"), szReplaceWord);

    if(countFrom == "last"){
        return value + lastWord;
    }else{
        return lastWord + value;
    }

}

// String.prototype.compare = function (szText) {
//     var thisStr = this.toString();
//     var textStr = szText.toString();
//     if (thisStr === textStr) {
//         return 0;
//     }
//     if (thisStr < textStr) {
//         return -1;
//     }
//     return 1;
// };

/**
 * Replicate ch as long as iWidth.
 * @param {string} ch. Should be single string. Example '0'
 * @param {int} iWidth. Example 4
 * @returns {string}. Return empty if iWidth <= 0. Example "0000"
 */
String.replicate = function (ch, iWidth) {
    var i, result = [];

    if (iWidth <= 0) {
        return "";
    }
    for (i = 0; i < iWidth; i += 1) {
        result[i] = ch;
    }
    return result.join('');
};